import React from 'react';
import { Alert } from '@amzn/awsui-components-react';
import { LockInfo } from 'src/models/common/LockInfo';
import { isLockedByOther } from './editLockUtils';

export interface LockBannerProps {
    lockInfo?: LockInfo | null;
    currentUser?: string;
    entityLabel?: string;
}

export function LockBanner({ lockInfo, currentUser, entityLabel = 'entity' }: LockBannerProps) {
    if (!isLockedByOther(lockInfo, currentUser)) {
        return null;
    }

    const lockedAtFormatted = lockInfo?.lockedAt
        ? new Date(lockInfo.lockedAt).toLocaleString()
        : undefined;

    return (
        <Alert type="warning" header={`${entityLabel.charAt(0).toUpperCase() + entityLabel.slice(1)} locked`}>
            This {entityLabel} is currently being edited by <strong>{lockInfo?.lockedBy || 'another user'}</strong>
            {lockedAtFormatted ? ` since ${lockedAtFormatted}` : ''}. You cannot make changes until they finish editing.
        </Alert>
    );
}

export default LockBanner;
